import * as Yup from 'yup';

export const IngExecutionClassSchema = Yup.object().shape({
    question0: Yup.string().required('Ce champ est requis'),
    question1: Yup.string().required('Ce champ est requis'),
    question2: Yup.string().required('Ce champ est requis'),
    question3: Yup.string().required('Ce champ est requis'),
})